if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getSelectedProductionSpeedVariant() {
        const sectionId = this.dataset.sectionId;
        const root =
          (sectionId &&
            document.querySelector(`product-production-speed[data-section-id="${sectionId}"]`)) ||
          document.querySelector('product-production-speed');
        if (!root) return null;

        const selected = root.querySelector('.product-production-speed__radio:checked');
        if (!selected) return null;

        const id = selected.dataset.ppsVariantId;
        if (!id) return null;

        return {
          id,
          label: selected.value || selected.dataset.ppsOption || '',
          price: Number(selected.dataset.ppsPrice) || 0,
        };
      }

      /**
       * Build FormData for /cart/add.
       * When Production Speed has a selected product, send both as items[] in one request.
       */
      buildAddToCartBody() {
        const formData = new FormData(this.form);
        const speed = this.getSelectedProductionSpeedVariant();
        const mainId = formData.get('id');

        const appendSections = (target) => {
          if (!this.cart) return;
          target.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          target.append('sections_url', window.location.pathname);
        };

        if (!speed?.id || String(speed.id) === String(mainId)) {
          appendSections(formData);
          return formData;
        }

        const multi = new FormData();
        const quantity = formData.get('quantity') || '1';

        multi.append('items[0][id]', mainId);
        multi.append('items[0][quantity]', quantity);

        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) multi.append('items[0][selling_plan]', sellingPlan);

        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match) {
            multi.append(`items[0][properties][${match[1]}]`, value);
          }
        }

        multi.append('items[1][id]', speed.id);
        multi.append('items[1][quantity]', '1');
        if (speed.label) {
          multi.append('items[1][properties][_Production Speed]', speed.label);
        }

        appendSections(multi);
        return multi;
      }

      normalizeCartAddResponse(response) {
        if (!response || response.status) return response;
        // Multi-item add returns { items: [...] } without top-level key/id
        if (Array.isArray(response.items) && response.items.length && !response.key) {
          const first = response.items[0];
          response.key = first.key;
          response.id = first.id;
          response.variant_id = first.variant_id;
        }
        return response;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        const formData = this.buildAddToCartBody();
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            response = this.normalizeCartAddResponse(response);

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id') || formData.get('items[0][id]'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id') || formData.get('items[0][id]'),
                cartData: response,
              });

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const quickViewModal = document.getElementById('product-quick-view');

            if (quickViewModal) {
              quickViewModal.classList.remove('quick-view-loaded');
              document.body.classList.remove('quickview-open');
            }

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
